'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remCalc = remCalc;

var _sizes = require('HubStyleTokens/sizes');

function remCalc(size) {
  return parseInt(size, 10) / parseInt(_sizes.ROOT_FONT_SIZE, 10) + 'rem';
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/core/Style.js
// module id = 17
// module chunks = 0